import SchoolTemplateFilters from "./SchoolTemplateFilters";
export default SchoolTemplateFilters;
